import { Toggle } from '@design/components/toggle/Toggle';
import { Statistics } from '@terminal/views/alfred/document-search/document-sources-view/document-sources-table/use-document-sources-table-store/useDocumentSourcesTableStore';
import { useDocumentSearch } from '@terminal/views/alfred/document-search/use-document-search/useDocumentSearch';
import { useSourcesFilterMessages } from '@terminal/views/alfred/document-search/use-sources-filter-messages/useSourcesFilterMessages';
import { useTranslation } from 'react-i18next';

import styles from './ChatInputContextHeader.module.scss';

interface ChatInputContextHeaderProps {
  contextCounts?: {
    documentsCount: number;
    subTypeCount: number;
    statistics?: Statistics;
  };
}

export const ChatInputContextHeader = ({
  contextCounts,
}: ChatInputContextHeaderProps) => {
  const { t } = useTranslation('chat');

  const { sourceSelectedBaseMessage } = useSourcesFilterMessages({
    totalDocuments: contextCounts?.documentsCount,
    totalCompanies: contextCounts?.subTypeCount,
    statistics: contextCounts?.statistics,
  });

  const { setIsSearchWithinContext, isSearchWithinContext, isMessagePending } =
    useDocumentSearch(state => ({
      setIsSearchWithinContext: state.setIsSearchWithinContext,
      isSearchWithinContext: state.isSearchWithinContext,
      isMessagePending: state.isMessagePending,
    }));

  return (
    <div className={styles.contextHeaderContainer} data-testid="context-header">
      <div className={styles.headerTextWrapper}>
        {isSearchWithinContext ? (
          <>
            <span
              className={styles.headerTextDefault}
              data-testid="enabled-context-label"
            >
              {t('contextHeader.searchWithinContext')}
            </span>
            <span className={styles.headerTextPrimary}>
              {sourceSelectedBaseMessage}
            </span>
          </>
        ) : (
          <span
            className={styles.headerTextDisabled}
            data-testid="disabled-context-label"
          >
            {t('contextHeader.searchWithinContext')}
          </span>
        )}
      </div>
      <Toggle
        className={styles.styledToggle}
        isChecked={isSearchWithinContext}
        onToggle={() => setIsSearchWithinContext(!isSearchWithinContext)}
        disabled={isMessagePending}
        aria-label={t('contextHeader.toggleSearchWithinContext')}
      />
    </div>
  );
};
